module.exports = __webpack_public_path__ + "img/Vector.1d24a052.svg";